import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import App from "./App";

// Auto-reload when a stale chunk hash is requested after a redeploy
window.addEventListener("vite:preloadError", () => { window.location.reload(); });
import { store } from "./app/store/store";
import { Provider } from "react-redux";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
